const translations = {
  en: {
    // Auth
    login: "Sign In", register: "Create Account", email: "Email", password: "Password",
    username: "Adventurer Name", enter_realm: "Enter the Realm", begin_adventure: "Begin Adventure",
    no_account: "No account? Create your legend", already_account: "Already an adventurer? Sign in",
    welcome_back: "Continue your adventure", begin_legend: "Begin your legend",
    // Menu
    new_adventure: "New Adventure", saved_adventures: "Saved Adventures",
    welcome: "Welcome", logout: "Logout", no_games: "No adventures yet",
    start_first: "Start your first adventure above!", delete_confirm: "Delete this adventure forever?",
    // Creation
    create_legend: "Create Your Legend", step_of: "Step {0} of {1}",
    choose_lang_name: "Choose your language & name", story_language: "Story Language",
    lang_hint: "The AI will generate the story in this language",
    character_name: "Character Name", enter_name: "Enter your character's name...",
    choose_class: "Choose your class", choose_world: "Choose your world",
    confirm_legend: "Confirm your legend", name: "Name", class_label: "Class",
    world: "World", language: "Language", starting_equipment: "Starting Equipment",
    continue_btn: "Continue", forging_world: "Forging your world...",
    starts_with: "Starts with",
    // Game HUD
    story: "Story", inventory: "Inventory", map: "Map", achievements: "Achievements",
    dashboard: "Stats", trade: "Trade", collection: "Collection", grimoire: "Chronicle", arena: "Arena",
    back_to_menu: "Back", battle_alert: "Battle!", start_battle: "Start Battle", battle_encounter_hint: "The enemy approaches. Read the scene, then engage when you're ready.", flee_battle: "Flee", flee_confirm_title: "Flee from battle?", flee_confirm_desc: "Retreating has a cost: you will lose one random card from your inventory (or 30 gold if no valuable cards). You cannot flee from boss battles.", flee_confirm_btn: "Yes, flee", flee_cancel_btn: "Stay and fight",
    // Story
    book_awaits: "The Book Awaits", open_book: "Open the Book",
    story_not_written: "Your story has not yet been written. Open the book and begin your adventure as",
    in_world: "in the world of", starting_items: "Starting items",
    writing_fate: "Writing your fate...", generating_story: "Generating story, images and events",
    retry_ink_wavers: "The ink wavers... regenerating the page",
    images_degraded_title: "Images temporarily unavailable",
    images_degraded_desc: "The art service is busy. Your story continues with text only — illustrations will return soon.",
    images_retry_in: "retry in",
    images_minutes: "min",
    pwa_install_title: "Install the app",
    pwa_install_desc: "Install Arcane Chronicles for faster loading, offline menu and a fullscreen experience.",
    what_do_you_do: "What do you do?", forge_own_path: "Or forge your own path:",
    describe_action: "Describe your action...", chapter: "Chapter",
    rewards_found: "Rewards", your_choice: "Your choice", prev: "Prev", next: "Next",
    pages: "pages", page: "page", generation_error: "Generation Error",
    ai_overloaded: "AI temporarily overloaded, please retry in a few seconds", ai_timeout: "AI took too long to respond. Please retry.", ai_budget: "AI credits exhausted. Please add balance to Universal Key or try later.",
    illustration_not_available: "Illustration not available",
    chronicle_continues: "The chronicle continues through words...",
    found_item: "Found", enemy_appears: "An enemy appears! Battle begins!",
    // Battle
    turn: "Turn", your_turn: "Your Turn", enemy_turn: "Enemy Turn",
    mana: "Mana", action_points: "Action Points", pa: "AP", armor: "Armor", cards_played: "Cards played",
    not_enough_pa: "Not enough Action Points!", not_enough_mana: "Not enough Mana!",
    combo_ready: "Combo ready!", your_hand: "Your Hand", end_turn: "End Turn",
    summon_ally: "Summon Ally", victory: "Victory!", defeated: "Defeated",
    enemy_defeated: "has been defeated!", escape_alive: "You managed to escape with your life...",
    continue_adventure: "Continue Adventure", xp_earned: "XP earned",
    allies_in_battle: "Your Allies in Battle",
    // Basic cards
    card_strike: "Strike", card_strike_desc: "Deal 2 damage to the enemy",
    card_block: "Block", card_block_desc: "Gain 2 armor points",
    card_heal: "Heal", card_heal_desc: "Restore 3 HP",
    card_power_strike: "Power Strike", card_power_strike_desc: "Deal 5 damage to the enemy",
    // Combos
    combo_double_strike: "Double Strike", combo_double_strike_desc: "Play 2 damage cards in one turn",
    combo_fortified: "Fortified Assault", combo_fortified_desc: "Play both attack and defense cards",
    combo_healing: "Healing Surge", combo_healing_desc: "Heal while an ally is on the field",
    combo_arcane: "Arcane Barrage", combo_arcane_desc: "Play 3+ cards in one turn",
    combo_guardian: "Guardian's Bond", combo_guardian_desc: "Defend with an ally on the field",
    combo_berserker: "Berserker Rage", combo_berserker_desc: "Play 4+ cards in one turn",
    // Inventory
    equipment: "Equipment", allies: "Allies", objects: "Objects", abilities: "Abilities", potions: "Potions", runes: "Runes", catalysts: "Sigils & Elixirs",
    equip: "Equip", unequip: "Remove", equipped: "Equipped", empty_slot: "Empty slot",
    weapon: "Weapon", armor_slot: "Armor", accessory: "Accessory",
    no_allies: "No allies in your party yet", 
    no_objects: "No objects in your inventory",
    no_abilities: "No abilities learned yet", 
    no_potions: "No potions in your inventory",
    no_runes: "No runes yet. Defeat enemies or find ancient shrines to obtain runes!",
    no_catalysts: "No sigils or elixirs in your inventory. Find them in card packs or buy them in the Shop!",
    generate_art: "Generate Art", equip_as: "Equip as", hold: "Capacity",
    insert_to_collection: "Insert into Collection",
    insert_confirm: "Are you sure you want to insert the card into the collection? It will be removed from the inventory.",
    send_to_inventory: "Send to Inventory",
    // Card upgrade
    upgrade: "Upgrade", upgrade_cost: "Cost: {0} XP", level: "Lv.",
    max_level: "MAX", card_upgraded: "Card upgraded!", not_enough_xp: "Not enough XP",
    enhanced: "Enhanced", legendary: "Legendary",
    // Map
    world_map: "World Map", generate_map: "Generate Map Image",
    no_locations: "No locations discovered yet", explore_more: "Continue your adventure to reveal the map",
    current_location: "Current", discovered: "Discovered",
    // Bestiary
    bestiary: "Bestiary", bestiary_title: "Bestiary",
    bestiary_defeated: "defeated", bestiary_empty: "No creatures encountered yet",
    bestiary_hint: "Battle enemies to fill your bestiary!",
    bestiary_slain: "Slain", bestiary_survived: "Escaped",
    bestiary_fought: "Fought",
    // Achievements
    achievements_title: "Achievements", locked: "Locked", unlocked: "Unlocked",
    achievement_unlocked: "Achievement Unlocked!", progress: "Progress",
    ach_first_chapter: "First Chapter", ach_first_chapter_desc: "Begin your first adventure",
    ach_bookworm: "Bookworm", ach_bookworm_desc: "Write 10 pages of your story",
    ach_epic_saga: "Epic Saga", ach_epic_saga_desc: "Write 50 pages of your story",
    ach_first_blood: "First Blood", ach_first_blood_desc: "Win your first battle",
    ach_veteran: "Veteran", ach_veteran_desc: "Win 10 battles",
    ach_warlord: "Warlord", ach_warlord_desc: "Win 25 battles",
    ach_combo_starter: "Combo Starter", ach_combo_starter_desc: "Trigger your first combo",
    ach_combo_master: "Combo Master", ach_combo_master_desc: "Trigger 10 combos",
    ach_collector: "Collector", ach_collector_desc: "Collect 10 cards",
    ach_hoarder: "Hoarder", ach_hoarder_desc: "Collect 25 cards",
    ach_explorer: "Explorer", ach_explorer_desc: "Discover 5 locations",
    ach_cartographer: "Cartographer", ach_cartographer_desc: "Discover 15 locations",
    ach_survivor: "Survivor", ach_survivor_desc: "Win a battle with less than 5 HP",
    ach_level5: "Seasoned Adventurer", ach_level5_desc: "Reach level 5",
    ach_level10: "Master Adventurer", ach_level10_desc: "Reach level 10",
    ach_first_ally: "Friendship", ach_first_ally_desc: "Recruit your first ally",
    ach_full_equip: "Fully Equipped", ach_full_equip_desc: "Equip weapon, armor and accessory",
    ach_card_upgrade: "Forge Master", ach_card_upgrade_desc: "Upgrade a card for the first time",
    ach_all_combos: "Combo Legend", ach_all_combos_desc: "Trigger all different combo types",
    ach_deal_100: "Damage Dealer", ach_deal_100_desc: "Deal 100 total damage",
    // Settings
    settings: "Settings", ui_language: "UI Language", ui_language_hint: "Change the interface language",
    story_lang_locked: "Story language is set during character creation",
    sound_effects: "Sound Effects", sound_on: "On", sound_off: "Off",
    story_font: "Story Font", font_cursive: "Cursive", font_classic: "Classic",
    font_cursive_desc: "Elegant, handwritten", font_classic_desc: "Clear, easy to read",
    font_preview: "Preview:", font_preview_text: "The hero walked into the ancient forest, where shadows danced between the trees...",
    delete_title: "Delete Adventure", delete_desc: "This action cannot be undone. The adventure will be permanently deleted.",
    cancel: "Cancel", confirm_delete: "Delete",
    // Boss & Chapters
    boss_battle: "BOSS BATTLE", boss_label: "BOSS", chapter_complete: "Chapter Complete",
    new_chapter: "New Chapter", chapter_num: "Chapter {0}",
    boss_defeated_msg: "The Boss has been defeated! Rare loot obtained!",
    boss_loot_title: "Boss Loot", rare: "Rare", epic: "Epic",
    rarity_common: "Common", rarity_uncommon: "Uncommon", rarity_rare: "Rare", rarity_epic: "Epic", rarity_legendary: "Legendary", rarity_divine: "Divine", foil: "Foil", new_item: "New Item!",
    boss_slayer_ach: "Boss Slayer", boss_slayer_desc: "Defeat your first boss",
    boss_hunter_ach: "Boss Hunter", boss_hunter_desc: "Defeat 3 bosses",
    boss_legend_ach: "Boss Legend", boss_legend_desc: "Defeat 5 bosses",
    rare_collector_ach: "Rare Collector", rare_collector_desc: "Collect 3 rare or epic cards",
    boss_special: "Special Ability",
    background_music: "Background Music", volume: "Volume",
    // Shop
    shop: "Shop", gold: "Gold", buy: "Buy", bought: "Purchased!",
    not_enough_gold: "Not enough gold", shop_potions: "Potions", shop_equipment: "Equipment", shop_allies: "Allies", shop_abilities: "Abilities", shop_runes: "Runes",
    shop_empty: "Nothing to buy here yet", price: "Price",
    use_item: "Use", item_used: "Item used!", item_heal_msg: "Healed {0} HP!",
    item_damage_msg: "Dealt {0} damage!", item_defense_msg: "Gained {0} armor!",
    item_battle_only: "Can only be used in battle", battle_inventory: "Inventory",
    // Payments & Limits
    daily_limit: "Daily Pages", pages_remaining: "Pages remaining",
    daily_limit_reached: "Daily limit reached!", buy_gold_unlock: "Buy gold to unlock unlimited pages",
    gold_packs: "Gold Packs", buy_pack: "Buy", premium_user: "Premium",
    unlimited_pages: "Unlimited pages", payment_success: "Payment successful! Gold added.",
    payment_cancelled: "Payment cancelled",
    // Stats & Evolution
    sphere_grid: "Sphere Grid", sphere_points: "Sphere Points",
    stat_points: "Sphere Points", allocate_stat: "Allocate Sphere Point",
    stat_hp: "Health", stat_atk: "Attack", stat_def: "Defense", stat_mana: "Mana",
    stat_allocated: "Stat increased!", level_up_title: "Level Up!",
    evolution_available: "Class Evolution Available!",
    evolve: "Evolve", evolve_to: "Evolve to", evolution_bonus: "Bonus",
    evolution_complete: "Class evolved!",
    choose_evolution: "Choose your evolution",
    // General
    loading: "Loading...", hp: "HP", xp: "XP", def: "DEF", atk: "ATK",
    level_label: "Level",
    // Categories
    cat_story: "Story", cat_combat: "Combat", cat_combos: "Combos",
    cat_collection: "Collection", cat_exploration: "Exploration",
    // Card types
    type_ally: "Ally", type_object: "Object", type_ability: "Ability",
    // Classes
    class_warrior: "Warrior", class_warrior_desc: "High HP, strong melee attacks, heavy armor",
    class_warrior_starting: "Iron Longsword + Shield Bash",
    class_mage: "Mage", class_mage_desc: "High mana, powerful spells, low defense",
    class_mage_starting: "Arcane Staff + Fireball + Mana Shield",
    class_rogue: "Rogue", class_rogue_desc: "Balanced stats, critical hits, stealth",
    class_rogue_starting: "Shadow Daggers + Backstab",
    class_ranger: "Ranger", class_ranger_desc: "Good HP, ranged attacks, nature magic",
    class_ranger_starting: "Elven Bow + Nature's Healing",
    class_necromancer: "Necromancer", class_necromancer_desc: "Summon undead, dark magic, life drain",
    class_necromancer_starting: "Bone Wand + Life Drain + Skeletal Minion",
    // Settings/Worlds
    setting_fantasy: "Fantasy", setting_fantasy_desc: "Enchanted kingdoms, noble quests and legendary creatures",
    setting_dark_fantasy: "Dark Fantasy", setting_dark_fantasy_desc: "A world of ancient magic and looming darkness",
    setting_sci_fi: "Sci-Fi", setting_sci_fi_desc: "Futuristic galaxies and alien civilizations",
    setting_horror: "Horror", setting_horror_desc: "Terrifying nightmares made real",
    setting_steampunk: "Steampunk", setting_steampunk_desc: "Victorian era meets advanced machinery",
    setting_post_apocalyptic: "Post-Apocalyptic", setting_post_apocalyptic_desc: "Survival in a ruined world",
    setting_mythology: "Mythology", setting_mythology_desc: "Gods, titans, and ancient legends",
    setting_shared_world: "Shared World", setting_shared_world_desc: "Navigate a single persistent server-wide world. Predefined landmarks and NPCs have a shared memory of all players' actions.",
    // Card Fusion
    fusion: "Fusion",
    select_cards_to_fuse: "Select 2 or more cards to fuse",
    insufficient_resources: "Not enough Gold or Dust",
    fusion_cost: "Fusion Cost",
    ritual_button: "Begin Fusion Ritual",
    ritual_loading_1: "Channeling void energies...",
    ritual_loading_2: "Merging card essences...",
    ritual_loading_3: "Forging a new legend...",
    fusion_success: "Fusion Complete!",
    fused_card_preview: "Fused Card Preview",
    fused_rarity: "Rarity Promotion",
    fused_foil: "Foil Sparkles Inherited! ✨",
  },
  it: {
    login: "Accedi", register: "Crea Account", email: "Email", password: "Password",
    username: "Nome Avventuriero", enter_realm: "Entra nel Regno", begin_adventure: "Inizia Avventura",
    no_account: "Nessun account? Crea la tua leggenda", already_account: "Gia un avventuriero? Accedi",
    welcome_back: "Continua la tua avventura", begin_legend: "Inizia la tua leggenda",
    new_adventure: "Nuova Avventura", saved_adventures: "Avventure Salvate",
    welcome: "Benvenuto", logout: "Esci", no_games: "Nessuna avventura ancora",
    start_first: "Inizia la tua prima avventura!", delete_confirm: "Eliminare questa avventura per sempre?",
    create_legend: "Crea la Tua Leggenda", step_of: "Passo {0} di {1}",
    choose_lang_name: "Scegli lingua e nome", story_language: "Lingua della Storia",
    lang_hint: "L'IA generera la storia in questa lingua",
    character_name: "Nome Personaggio", enter_name: "Inserisci il nome del personaggio...",
    choose_class: "Scegli la tua classe", choose_world: "Scegli il tuo mondo",
    confirm_legend: "Conferma la tua leggenda", name: "Nome", class_label: "Classe",
    world: "Mondo", language: "Lingua", starting_equipment: "Equipaggiamento Iniziale",
    continue_btn: "Continua", forging_world: "Creando il tuo mondo...",
    starts_with: "Inizia con",
    story: "Storia", inventory: "Inventario", map: "Mappa", achievements: "Trofei",
    dashboard: "Stats", trade: "Scambi", collection: "Collezione", grimoire: "Grimorio", arena: "Arena",
    back_to_menu: "Menu", battle_alert: "Battaglia!", start_battle: "Inizia Battaglia", battle_encounter_hint: "Il nemico si avvicina. Leggi la scena, poi affrontalo quando sei pronto.", flee_battle: "Fuggi", flee_confirm_title: "Fuggire dalla battaglia?", flee_confirm_desc: "La ritirata ha un prezzo: perderai una carta casuale dall'inventario (o 30 oro se non hai carte di valore). Non puoi fuggire dai boss.", flee_confirm_btn: "Sì, fuggi", flee_cancel_btn: "Resta e combatti",
    book_awaits: "Il Libro Attende", open_book: "Apri il Libro",
    story_not_written: "La tua storia non e ancora scritta. Apri il libro e inizia la tua avventura come",
    in_world: "nel mondo di", starting_items: "Oggetti iniziali",
    writing_fate: "Scrivendo il tuo destino...", generating_story: "Generando storia, immagini ed eventi",
    retry_ink_wavers: "L'inchiostro vacilla... rigenero la pagina",
    images_degraded_title: "Immagini temporaneamente non disponibili",
    images_degraded_desc: "Il servizio artistico è affollato. La storia continua solo con il testo — le illustrazioni torneranno a breve.",
    images_retry_in: "nuovo tentativo tra",
    images_minutes: "min",
    pwa_install_title: "Installa l'app",
    pwa_install_desc: "Installa Arcane Chronicles per un caricamento più rapido, menu offline e un'esperienza a schermo intero.",
    what_do_you_do: "Cosa fai?", forge_own_path: "Oppure scegli la tua strada:",
    describe_action: "Descrivi la tua azione...", chapter: "Capitolo",
    rewards_found: "Ricompense", your_choice: "La tua scelta", prev: "Prec", next: "Succ",
    pages: "pagine", page: "pagina", generation_error: "Errore di Generazione",
    ai_overloaded: "IA momentaneamente sovraccarica, riprova tra qualche secondo", ai_timeout: "L'IA ci ha messo troppo a rispondere. Riprova.", ai_budget: "Crediti IA esauriti. Aggiungi saldo alla Universal Key o riprova più tardi.",
    illustration_not_available: "Illustrazione non disponibile",
    chronicle_continues: "La cronaca prosegue attraverso le parole...",
    found_item: "Trovato", enemy_appears: "Un nemico appare! Inizia la battaglia!",
    turn: "Turno", your_turn: "Il Tuo Turno", enemy_turn: "Turno Nemico",
    mana: "Mana", action_points: "Punti Azione", pa: "PA", armor: "Armatura", cards_played: "Carte giocate",
    not_enough_pa: "Punti Azione insufficienti!", not_enough_mana: "Mana insufficiente!",
    combo_ready: "Combo pronta!", your_hand: "La Tua Mano", end_turn: "Fine Turno",
    summon_ally: "Evoca Alleato", victory: "Vittoria!", defeated: "Sconfitto",
    enemy_defeated: "e stato sconfitto!", escape_alive: "Sei riuscito a fuggire con la tua vita...",
    continue_adventure: "Continua Avventura", xp_earned: "XP guadagnati",
    allies_in_battle: "I Tuoi Alleati in Battaglia",
    // Basic cards
    card_strike: "Colpo", card_strike_desc: "Infliggi 2 danni al nemico",
    card_block: "Parata", card_block_desc: "Ottieni 2 punti armatura",
    card_heal: "Cura", card_heal_desc: "Ripristina 3 PV",
    card_power_strike: "Colpo Potente", card_power_strike_desc: "Infliggi 5 danni al nemico",
    // Combos
    combo_double_strike: "Doppio Colpo", combo_double_strike_desc: "Gioca 2 carte danno in un turno",
    combo_fortified: "Assalto Fortificato", combo_fortified_desc: "Gioca carte attacco e difesa insieme",
    combo_healing: "Ondata di Cura", combo_healing_desc: "Curati mentre un alleato e in campo",
    combo_arcane: "Scarica Arcana", combo_arcane_desc: "Gioca 3+ carte in un turno",
    combo_guardian: "Legame del Guardiano", combo_guardian_desc: "Difenditi con un alleato in campo",
    combo_berserker: "Furia del Berserker", combo_berserker_desc: "Gioca 4+ carte in un turno",
    // Inventory
    equipment: "Equipaggiamento", allies: "Alleati", objects: "Oggetti", abilities: "Abilità", potions: "Pozioni", runes: "Rune", catalysts: "Sigilli & Elisir",
    equip: "Equipaggia", unequip: "Rimuovi", equipped: "Equipaggiato", empty_slot: "Slot vuoto",
    weapon: "Arma", armor_slot: "Armatura", accessory: "Accessorio",
    no_allies: "Nessun alleato ancora. Esplora il mondo per trovare compagni!",
    no_objects: "Nessun oggetto ancora. Cerca tesori nel tuo viaggio!",
    no_abilities: "Nessuna abilità ancora. Impara abilità potenti nella tua missione!",
    no_potions: "Nessuna pozione ancora. Acquistale al negozio o trovale nel tuo viaggio!",
    no_runes: "Nessuna runa ancora. Sconfiggi nemici o trova antichi santuari per ottenere rune!",
    no_catalysts: "Nessun sigillo o elisir nell'inventario. Trovali nelle bustine o acquistali nel Negozio!",
    generate_art: "Genera Arte", equip_as: "Equipaggia come", hold: "Zaino",
    insert_to_collection: "Inserisci nella collezione",
    insert_confirm: "Sicuro di voler inserire la carta nella collezione? Verrà rimossa dall'inventario",
    send_to_inventory: "Invia all'inventario",
    upgrade: "Potenzia", upgrade_cost: "Costo: {0} XP", level: "Lv.",
    max_level: "MAX", card_upgraded: "Carta potenziata!", not_enough_xp: "XP insufficienti",
    enhanced: "Potenziato", legendary: "Leggendario",
    world_map: "Mappa del Mondo", generate_map: "Genera Immagine Mappa",
    no_locations: "Nessun luogo scoperto ancora", explore_more: "Continua la tua avventura per rivelare la mappa",
    current_location: "Attuale", discovered: "Scoperto",
    // Bestiary
    bestiary: "Bestiario", bestiary_title: "Bestiario",
    bestiary_defeated: "sconfitti", bestiary_empty: "Nessuna creatura incontrata ancora",
    bestiary_hint: "Combatti nemici per riempire il tuo bestiario!",
    bestiary_slain: "Ucciso", bestiary_survived: "Fuggito",
    bestiary_fought: "Combattuto",
    achievements_title: "Trofei", locked: "Bloccato", unlocked: "Sbloccato",
    achievement_unlocked: "Trofeo Sbloccato!", progress: "Progresso",
    // Achievements
    ach_first_chapter: "Primo Capitolo", ach_first_chapter_desc: "Inizia la tua prima avventura",
    ach_bookworm: "Topo di Biblioteca", ach_bookworm_desc: "Scrivi 10 pagine della tua storia",
    ach_epic_saga: "Saga Epica", ach_epic_saga_desc: "Scrivi 50 pagine della tua storia",
    ach_first_blood: "Primo Sangue", ach_first_blood_desc: "Vinci la tua prima battaglia",
    ach_veteran: "Veterano", ach_veteran_desc: "Vinci 10 battaglie",
    ach_warlord: "Signore della Guerra", ach_warlord_desc: "Vinci 25 battaglie",
    ach_combo_starter: "Apprendista Combo", ach_combo_starter_desc: "Attiva la tua prima combo",
    ach_combo_master: "Maestro delle Combo", ach_combo_master_desc: "Attiva 10 combo",
    ach_collector: "Collezionista", ach_collector_desc: "Colleziona 10 carte",
    ach_hoarder: "Accumulatore", ach_hoarder_desc: "Colleziona 25 carte",
    ach_explorer: "Esploratore", ach_explorer_desc: "Scopri 5 luoghi",
    ach_cartographer: "Cartografo", ach_cartographer_desc: "Scopri 15 luoghi",
    ach_survivor: "Sopravvissuto", ach_survivor_desc: "Vinci una battaglia con meno di 5 PV",
    ach_level5: "Avventuriero Esperto", ach_level5_desc: "Raggiungi il livello 5",
    ach_level10: "Avventuriero Maestro", ach_level10_desc: "Raggiungi il livello 10",
    ach_first_ally: "Amicizia", ach_first_ally_desc: "Recluta il tuo primo alleato",
    ach_full_equip: "Completamente Equipaggiato", ach_full_equip_desc: "Equipaggia arma, armatura e accessorio",
    ach_card_upgrade: "Maestro della Forgia", ach_card_upgrade_desc: "Potenzia una carta per la prima volta",
    ach_all_combos: "Leggenda delle Combo", ach_all_combos_desc: "Attiva tutti i tipi di combo",
    ach_deal_100: "Dispensatore di Danni", ach_deal_100_desc: "Infliggi 100 danni totali",
    // Settings
    settings: "Impostazioni", ui_language: "Lingua Interfaccia",
    ui_language_hint: "Cambia la lingua dell'interfaccia",
    story_lang_locked: "La lingua della storia e impostata durante la creazione del personaggio",
    sound_effects: "Effetti Sonori", sound_on: "Attivi", sound_off: "Disattivati",
    story_font: "Carattere della Storia", font_cursive: "Corsivo", font_classic: "Classico",
    font_cursive_desc: "Elegante, scritto a mano", font_classic_desc: "Chiaro, facile da leggere",
    font_preview: "Anteprima:", font_preview_text: "L'eroe si adentro nella foresta antica, dove le ombre danzavano tra gli alberi...",
    delete_title: "Elimina Avventura", delete_desc: "Questa azione non puo essere annullata. L'avventura sara eliminata per sempre.",
    cancel: "Annulla", confirm_delete: "Elimina",
    // Boss & Chapters
    boss_battle: "BATTAGLIA BOSS", boss_label: "BOSS", chapter_complete: "Capitolo Completato",
    new_chapter: "Nuovo Capitolo", chapter_num: "Capitolo {0}",
    boss_defeated_msg: "Il Boss e stato sconfitto! Bottino raro ottenuto!",
    boss_loot_title: "Bottino del Boss", rare: "Raro", epic: "Epico",
    rarity_common: "Comune", rarity_uncommon: "Non Comune", rarity_rare: "Raro", rarity_epic: "Epico", rarity_legendary: "Leggendario", rarity_divine: "Divino", foil: "Foil", new_item: "Nuovo Oggetto!",
    boss_slayer_ach: "Ammazza Boss", boss_slayer_desc: "Sconfiggi il tuo primo boss",
    boss_hunter_ach: "Cacciatore di Boss", boss_hunter_desc: "Sconfiggi 3 boss",
    boss_legend_ach: "Leggenda dei Boss", boss_legend_desc: "Sconfiggi 5 boss",
    rare_collector_ach: "Collezionista Raro", rare_collector_desc: "Colleziona 3 carte rare o epiche",
    boss_special: "Abilita Speciale",
    background_music: "Musica di Sottofondo", volume: "Volume",
    // Shop
    shop: "Negozio", gold: "Oro", buy: "Compra", bought: "Acquistato!",
    not_enough_gold: "Oro insufficiente", shop_potions: "Pozioni", shop_equipment: "Equipaggiamento", shop_allies: "Alleati", shop_abilities: "Abilità", shop_runes: "Rune",
    shop_empty: "Niente da comprare qui ancora", price: "Prezzo",
    use_item: "Usa", item_used: "Oggetto usato!", item_heal_msg: "Curato {0} PV!",
    item_damage_msg: "Inflitto {0} danni!", item_defense_msg: "Ottenuto {0} armatura!",
    item_battle_only: "Utilizzabile solo in battaglia", battle_inventory: "Inventario",
    // Payments & Limits
    daily_limit: "Pagine Giornaliere", pages_remaining: "Pagine rimanenti",
    daily_limit_reached: "Limite giornaliero raggiunto!", buy_gold_unlock: "Acquista oro per sbloccare pagine illimitate",
    gold_packs: "Pacchetti Oro", buy_pack: "Acquista", premium_user: "Premium",
    unlimited_pages: "Pagine illimitate", payment_success: "Pagamento riuscito! Oro aggiunto.",
    payment_cancelled: "Pagamento annullato",
    // Stats & Evolution
    sphere_grid: "Sferografia", sphere_points: "Punti Sfera",
    stat_points: "Punti Sfera", allocate_stat: "Assegna Punto Sfera",
    stat_hp: "Vita", stat_atk: "Attacco", stat_def: "Difesa", stat_mana: "Mana",
    stat_allocated: "Statistica aumentata!", level_up_title: "Livello Su!",
    evolution_available: "Evoluzione Classe Disponibile!",
    evolve: "Evolvi", evolve_to: "Evolvi in", evolution_bonus: "Bonus",
    evolution_complete: "Classe evoluta!",
    choose_evolution: "Scegli la tua evoluzione",
    loading: "Caricamento...", hp: "PV", xp: "XP", def: "DIF", atk: "ATT",
    level_label: "Livello",
    // Categories
    cat_story: "Storia", cat_combat: "Combattimento", cat_combos: "Combo",
    cat_collection: "Collezione", cat_exploration: "Esplorazione",
    // Card types
    type_ally: "Alleato", type_object: "Oggetto", type_ability: "Abilita",
    // Classes
    class_warrior: "Guerriero", class_warrior_desc: "PV alti, forti attacchi ravvicinati, armatura pesante",
    class_warrior_starting: "Spadone di Ferro + Colpo di Scudo",
    class_mage: "Mago", class_mage_desc: "Mana alto, incantesimi potenti, difesa bassa",
    class_mage_starting: "Bastone Arcano + Palla di Fuoco + Scudo di Mana",
    class_rogue: "Ladro", class_rogue_desc: "Statistiche bilanciate, colpi critici, furtivita",
    class_rogue_starting: "Pugnali d'Ombra + Pugnalata alle Spalle",
    class_ranger: "Ranger", class_ranger_desc: "Buoni PV, attacchi a distanza, magia naturale",
    class_ranger_starting: "Arco Elfico + Cura della Natura",
    class_necromancer: "Negromante", class_necromancer_desc: "Evoca non morti, magia oscura, risucchio vitale",
    class_necromancer_starting: "Bacchetta d'Osso + Risucchio Vitale + Servitore Scheletrico",
    // Settings/Worlds
    setting_fantasy: "Fantasy", setting_fantasy_desc: "Regni incantati, nobili missioni e creature leggendarie",
    setting_dark_fantasy: "Dark Fantasy", setting_dark_fantasy_desc: "Un mondo di magia antica e tenebre incombenti",
    setting_sci_fi: "Fantascienza", setting_sci_fi_desc: "Galassie futuristiche e civilta aliene",
    setting_horror: "Horror", setting_horror_desc: "Incubi terrificanti divenuti realta",
    setting_steampunk: "Steampunk", setting_steampunk_desc: "L'era vittoriana incontra la meccanica avanzata",
    setting_post_apocalyptic: "Post-Apocalittico", setting_post_apocalyptic_desc: "Sopravvivenza in un mondo in rovina",
    setting_mythology: "Mitologia", setting_mythology_desc: "Dei, titani e antiche leggende",
    setting_shared_world: "Mondo Unico", setting_shared_world_desc: "Naviga in un unico mondo persistente condiviso sul server. Punti di riferimento fissi e NPC mantengono una memoria comune di tutti i giocatori.",
    // Card Fusion
    fusion: "Fusione",
    select_cards_to_fuse: "Seleziona 2 o più carte da fondere",
    insufficient_resources: "Oro o Polvere insufficienti",
    fusion_cost: "Costo della Fusione",
    ritual_button: "Inizia il Rituale di Fusione",
    ritual_loading_1: "Canalizzando le energie del vuoto...",
    ritual_loading_2: "Fondendo le essenze delle carte...",
    ritual_loading_3: "Forgiando una nuova leggenda...",
    fusion_success: "Fusione Completata!",
    fused_card_preview: "Anteprima Carta Fusa",
    fused_rarity: "Promozione Rarità",
    fused_foil: "Bagliore Foil Ereditato! ✨",
  },
  es: {
    login: "Iniciar Sesion", register: "Crear Cuenta", email: "Email", password: "Contrasena",
    username: "Nombre de Aventurero", enter_realm: "Entrar al Reino", begin_adventure: "Comenzar Aventura",
    no_account: "Sin cuenta? Crea tu leyenda", already_account: "Ya eres aventurero? Inicia sesion",
    welcome_back: "Continua tu aventura", begin_legend: "Comienza tu leyenda",
    new_adventure: "Nueva Aventura", saved_adventures: "Aventuras Guardadas",
    welcome: "Bienvenido", logout: "Salir", no_games: "Sin aventuras aun",
    start_first: "Comienza tu primera aventura!", story: "Historia", inventory: "Inventario",
    map: "Mapa", achievements: "Logros", book_awaits: "El Libro Espera",
    open_book: "Abrir el Libro", what_do_you_do: "Que haces?", continue_btn: "Continuar",
    victory: "Victoria!", defeated: "Derrotado", continue_adventure: "Continuar Aventura",
    equipment: "Equipamiento", allies: "Aliados", objects: "Objetos", abilities: "Habilidades",
    insert_to_collection: "Insertar en la colección",
    insert_confirm: "¿Estás seguro de que quieres insertar la carta en la colección? Se eliminará del inventario.",
    send_to_inventory: "Enviar al inventario",
    upgrade: "Mejorar", world_map: "Mapa del Mundo", achievements_title: "Logros", hold: "Mochila",
    loading: "Cargando...", hp: "PV", level: "Nv.", your_turn: "Tu Turno",
    enemy_turn: "Turno Enemigo", end_turn: "Fin del Turno", your_hand: "Tu Mano",
    chapter: "Capitulo", turn: "Turno",
    create_legend: "Crea Tu Leyenda", choose_class: "Elige tu clase", choose_world: "Elige tu mundo",
    confirm_legend: "Confirma tu leyenda", name: "Nombre", class_label: "Clase",
    world: "Mundo", language: "Idioma", character_name: "Nombre del Personaje",
    writing_fate: "Escribiendo tu destino...",
    card_strike: "Golpe", card_block: "Bloqueo", card_heal: "Curar", card_power_strike: "Golpe Poderoso",
    combo_double_strike: "Doble Golpe", combo_fortified: "Asalto Fortificado",
    ach_first_chapter: "Primer Capitulo", ach_first_blood: "Primera Sangre",
    ach_veteran: "Veterano", ach_explorer: "Explorador",
    cat_story: "Historia", cat_combat: "Combate", cat_combos: "Combos",
    cat_collection: "Coleccion", cat_exploration: "Exploracion",
    type_ally: "Aliado", type_object: "Objeto", type_ability: "Habilidad",
  },
  fr: {
    login: "Connexion", register: "Creer un Compte", begin_adventure: "Commencer Aventure",
    new_adventure: "Nouvelle Aventure", saved_adventures: "Aventures Sauvegardees",
    welcome: "Bienvenue", logout: "Deconnexion", story: "Histoire", inventory: "Inventaire",
    map: "Carte", achievements: "Succes", book_awaits: "Le Livre Attend",
    open_book: "Ouvrir le Livre", what_do_you_do: "Que faites-vous?", continue_btn: "Continuer",
    victory: "Victoire!", defeated: "Vaincu", equipment: "Equipement",
    allies: "Allies", objects: "Objets", abilities: "Capacites", upgrade: "Ameliorer", hold: "Sac",
    insert_to_collection: "Insérer dans la collection",
    insert_confirm: "Êtes-vous sûr de vouloir insérer la carte dans la collection ? Elle sera retirée de l'inventaire.",
    send_to_inventory: "Envoyer à l'inventaire",
    world_map: "Carte du Monde", achievements_title: "Succes", loading: "Chargement...",
    your_turn: "Votre Tour", enemy_turn: "Tour Ennemi", end_turn: "Fin du Tour",
    chapter: "Chapitre", turn: "Tour",
    create_legend: "Creez Votre Legende", choose_class: "Choisissez votre classe",
    choose_world: "Choisissez votre monde", name: "Nom", class_label: "Classe",
    world: "Monde", language: "Langue", character_name: "Nom du Personnage",
    writing_fate: "Ecrivant votre destin...",
    card_strike: "Frappe", card_block: "Blocage", card_heal: "Soin", card_power_strike: "Frappe Puissante",
    combo_double_strike: "Double Frappe", combo_fortified: "Assaut Fortifie",
    cat_story: "Histoire", cat_combat: "Combat", cat_combos: "Combos",
    cat_collection: "Collection", cat_exploration: "Exploration",
    type_ally: "Allie", type_object: "Objet", type_ability: "Capacite",
  },
  de: {
    login: "Anmelden", register: "Konto Erstellen", begin_adventure: "Abenteuer Beginnen",
    new_adventure: "Neues Abenteuer", saved_adventures: "Gespeicherte Abenteuer",
    welcome: "Willkommen", logout: "Abmelden", story: "Geschichte", inventory: "Inventar",
    map: "Karte", achievements: "Erfolge", book_awaits: "Das Buch Wartet",
    open_book: "Buch Offnen", what_do_you_do: "Was tust du?", continue_btn: "Weiter",
    victory: "Sieg!", defeated: "Besiegt", equipment: "Ausrustung",
    allies: "Verbundete", objects: "Gegenstande", abilities: "Fahigkeiten", upgrade: "Verbessern", hold: "Tasche",
    insert_to_collection: "In Sammlung einfügen",
    insert_confirm: "Möchten Sie die Karte wirklich in die Sammlung einfügen? Sie wird aus dem Inventar entfernt.",
    send_to_inventory: "Ins Inventar senden",
    world_map: "Weltkarte", achievements_title: "Erfolge", loading: "Laden...",
    your_turn: "Dein Zug", enemy_turn: "Gegnerzug", end_turn: "Zug Beenden",
    chapter: "Kapitel", turn: "Zug",
    create_legend: "Erstelle Deine Legende", choose_class: "Wahle deine Klasse",
    choose_world: "Wahle deine Welt", name: "Name", class_label: "Klasse",
    world: "Welt", language: "Sprache", character_name: "Charaktername",
    writing_fate: "Schreibe dein Schicksal...",
    card_strike: "Schlag", card_block: "Blocken", card_heal: "Heilen", card_power_strike: "Kraftschlag",
    combo_double_strike: "Doppelschlag", combo_fortified: "Befestigter Angriff",
    cat_story: "Geschichte", cat_combat: "Kampf", cat_combos: "Kombos",
    cat_collection: "Sammlung", cat_exploration: "Erkundung",
    type_ally: "Verbundeter", type_object: "Gegenstand", type_ability: "Fahigkeit",
  },
  pt: {
    login: "Entrar", register: "Criar Conta", begin_adventure: "Comecar Aventura",
    new_adventure: "Nova Aventura", saved_adventures: "Aventuras Salvas",
    welcome: "Bem-vindo", logout: "Sair", story: "Historia", inventory: "Inventario",
    map: "Mapa", achievements: "Conquistas", continue_btn: "Continuar",
    victory: "Vitoria!", defeated: "Derrotado", equipment: "Equipamento",
    allies: "Aliados", objects: "Objetos", abilities: "Habilidades", upgrade: "Melhorar", hold: "Mochila",
    insert_to_collection: "Inserir na coleção",
    insert_confirm: "Tem certeza de que deseja inserir a carta na coleção? Ela será removida do inventário.",
    send_to_inventory: "Enviar para o inventário",
    loading: "Carregando...", your_turn: "Seu Turno", enemy_turn: "Turno Inimigo",
    chapter: "Capitulo", turn: "Turno",
    create_legend: "Crie Sua Lenda", name: "Nome", class_label: "Classe",
    world: "Mundo", language: "Idioma",
    writing_fate: "Escrevendo seu destino...",
    card_strike: "Golpe", card_block: "Bloqueio", card_heal: "Curar", card_power_strike: "Golpe Poderoso",
    combo_double_strike: "Golpe Duplo", combo_fortified: "Assalto Fortificado",
    cat_story: "Historia", cat_combat: "Combate", cat_combos: "Combos",
    cat_collection: "Colecao", cat_exploration: "Exploracao",
    type_ally: "Aliado", type_object: "Objeto", type_ability: "Habilidade",
  }
};

import { useState, useEffect } from "react";

// Fallback chain: requested lang -> en
export function t(lang, key) {
  return translations[lang]?.[key] || translations.en?.[key] || key;
}

// Template function: t(lang, 'upgrade_cost', [50]) -> "Cost: 50 XP"
export function tf(lang, key, args = []) {
  let str = t(lang, key);
  args.forEach((arg, i) => {
    str = str.replace(`{${i}}`, arg);
  });
  return str;
}

// Get stored UI language (for non-game pages and global components)
export function getStoredLang() {
  try {
    const stored = localStorage.getItem('ac_lang') || localStorage.getItem('ac_ui_lang');
    if (stored) return stored;
    const nav = (typeof navigator !== 'undefined' && navigator.language ? navigator.language.slice(0, 2) : 'it');
    return nav === 'it' ? 'it' : 'en';
  } catch {
    return 'it';
  }
}

export function setStoredLang(lang) {
  try {
    localStorage.setItem('ac_lang', lang);
    localStorage.setItem('ac_ui_lang', lang);
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('ac_lang_changed', { detail: lang }));
    }
  } catch {
    /* noop */
  }
}

// Reusable hook to subscribe reactively to language changes across the app
export function useCurrentLang() {
  const [currentLang, setCurrentLang] = useState(getStoredLang);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const handleLangChange = (e) => {
      if (e && e.detail) setCurrentLang(e.detail);
      else setCurrentLang(getStoredLang());
    };

    window.addEventListener('ac_lang_changed', handleLangChange);
    window.addEventListener('storage', handleLangChange);

    return () => {
      window.removeEventListener('ac_lang_changed', handleLangChange);
      window.removeEventListener('storage', handleLangChange);
    };
  }, []);

  return [currentLang, setStoredLang];
}


export default translations;

